/*
*
* Copyright (c) 2013 Curse, Inc.)
* Cobalt.QueryParser is designed to parser a request's query string, and provide an object oriented way to manipulate it. 
*
*/

Cobalt.QueryParser = function (queryString) {

    this.originalQuery = queryString;
    this.keyValuePairs = [];

    var re = /([^&=]+)=?([^&]*)/g;
    var decodeRE = /\+/g;  // Regex for replacing addition symbol with a space
    var decode = function (str) { return decodeURIComponent(str.replace(decodeRE, " ")); };

    // Strip everything before the '?' character
    var firstParamIndex = queryString.indexOf("?");
    if (firstParamIndex >= 0) {
        queryString = queryString.substring(firstParamIndex + 1);
    } else {
        queryString = "";
    }

    var match;
    while (match = re.exec(queryString)) {
        var k = decode(match[1]);
        var v = decode(match[2]);
        this.keyValuePairs.push({ key: k, value: v });
    }

};


Cobalt.QueryParser.prototype =
{
    originalQuery: null,
    keyValuePairs: null,
    toString: function () {
        var val = "";
        for (var i = 0; i < this.keyValuePairs.length; i++) {
            var kvp = this.keyValuePairs[i];
            val += "&" + kvp.key + "=" + kvp.value;
        }

        val = "?" + val.substring(1);

        return val;
    },
    getByKey: function (key) {
        for (var i = 0; i < this.keyValuePairs.length; i++) {
            if (key === this.keyValuePairs[i].key) {
                return this.keyValuePairs[i].value;
            }
        }
        return undefined;
    },
    set: function (key, value) {
        // Look for an existing value
        var found = false;
        for (var i = 0; i < this.keyValuePairs.length; i++) {
            var kvp = this.keyValuePairs[i];
            if (kvp.key == key) {
                kvp.value = value;
                found = true;
            }
        }

        if (!found) {
            this.keyValuePairs.push({ key: key, value: value });
        }
    },
    add: function (key, value) {
        this.keyValuePairs.push({ key: key, value: value });
    },
    mergeFrom: function (values) {        
        for (var i = 0; i < values.length; i++) {
            var kvp = values[i];
            this.set(kvp.key, kvp.value);
        }
    }
}


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.QueryParser.js